/**
 * Inservice External Integrations
 * Inservice external integrations API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VirtualLocationProviderLoginDto { 
    email?: string;
    redirectUri: string;
    provider: VirtualLocationProviderLoginDto.ProviderEnum;
}
export namespace VirtualLocationProviderLoginDto {
    export type ProviderEnum = 'office365';
    export const ProviderEnum = {
        Office365: 'office365' as ProviderEnum
    };
}


